import { UserRoleEnum } from 'enums'
import { RWDashboard } from 'layout'
import { ReactElement } from 'react'
import { ProtectedRoute } from './ProtectedRoute'

export type ProtectedRouteWithDashboardProps = {
  role: UserRoleEnum | Array<UserRoleEnum>
  children: ReactElement
}
function ProtectedRouteWithDashboard(props: ProtectedRouteWithDashboardProps) {
  return (
    <ProtectedRoute role={props.role}>
      <RWDashboard>{props.children}</RWDashboard>
    </ProtectedRoute>
  )
}
export default ProtectedRouteWithDashboard
